var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-header'),_c('v-content',[(_vm.getFeedback)?_c('v-alert',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.getFeedback))]):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }